import InnerLayout from "@/views/inner-layout";
export default [
  {
    path: '/promotion',
    component: InnerLayout,
    redirect: '/promotion',
    meta: {
      title: 'rpt.listRptPromotions', //促销
    },
    children: [
    //   {
    //     path: "PromotionDocuments/yearendcommendation",
    //     component: () =>
    //       import("@/views/PromotionDocuments/yearendcommendation"),
    //     name: "YearEndCommendation",
    //     meta: { title: "Year-end.commendation.conference.promotion" }, // 年终表彰会议促销
    //   },
      {
        path: "my-coupon/index",
        component: () => import("@/views/order-coupon/my-coupon.vue"),
        name: "MyCoupon",
        meta: { title: "My_Coupon" }, // 我的优惠券
      },
      {
        path: "order-coupon/index",
        component: () => import("@/views/order-coupon/order-coupon.vue"),
        name: "OrderCoupon",
        meta: { title: "order.youhuiquan.no" }, // 优惠券报单
      },
    ],
  },
];
